import { makeStyles, Theme } from '@material-ui/core/styles'
import { Project } from 'Models/project'
import React from 'react'

const useStyles = makeStyles((theme: Theme) => ({
    mapSize: { width: '100%', height: 212, border: 0 },
}))

const API_KEY = 'AIzaSyD43Me9VnlJ53u6wXEdFf9s1aus3MaFv24'

interface ProjectGoogleMapProps {
    projectData: Partial<Project> | undefined
}
export const ProjectGoogleMap: React.FC<ProjectGoogleMapProps> = ({
    projectData,
}) => {
    const classes = useStyles()
    let address = ''
    if (!!projectData) {
        const {
            street1,
            city,
            region,
            country,
            postalCode,
        } = projectData?.location!

        address = encodeURIComponent(
            `${street1},${city},${region},${country},${postalCode}`
        ).replace(/%20/g, '+')
    } else {
        return null
    }

    return (
        <iframe
            data-testid="projectGoogleMap"
            title="project address"
            className={classes.mapSize}
            frame-border="0"
            src={`https://www.google.com/maps/embed/v1/place?key=${API_KEY}&q=${address}`}
            allowFullScreen
        />
    )
}
export default ProjectGoogleMap
